export default {
  allowedTags: [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'p',
    'a',
    'ul',
    'ol',
    'nl',
    'li',
    'b',
    'i',
    'strong',
    'em',
    'strike',
    'code',
    'hr',
    'br',
    'div',
    'table',
    'thead',
    'caption',
    'tbody',
    'tr',
    'th',
    'td',
    'pre',
    'img',
    'button',
    'iframe',
    'sub',
    'sup',
    's',
  ],
  allowedAttributes: {
    a: ['style', 'href', 'name', 'target', 'class'],
    img: [
      'style',
      'src',
      'height',
      'width',
      'data-type',
      'data-id',
      'data-name',
      'class',
    ],
    div: ['style', 'id', 'class'],
    button: ['style', 'type'],
    span: ['style', 'class', 'contenteditable'],
    th: ['colspan', 'style'],
    td: ['style'],
    iframe: [
      'src',
      'allowfullscreen',
      'class',
      'width',
      'height',
      'frameborder',
    ],
    p: ['style', 'class'],
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: [
    'img',
    'br',
    'hr',
    'area',
    'base',
    'basefont',
    'input',
    'link',
    'meta',
  ],
  // URL schemes we permit
  allowedSchemes: ['http', 'https', 'ftp', 'mailto'],
  allowedSchemesByTag: {},
  allowProtocolRelative: true,
};



// WEBPACK FOOTER //
// ./src/configs/allowedTags.js